export const RoleUrl = {
  SEARCH:
    '/roles{?page,size,sort*,name,permissions*,accessGroups*,selectedIds*,description}',
  ROLE: '/roles{/id}',
} as const;
